
export const SET_USERAPPSETTINGS_STATE = 'SET_USERAPPSETTINGS_STATE';

export function setUserAppSettingsState(data) {
	return async dispatch => {
		dispatch({
			type: SET_USERAPPSETTINGS_STATE,
			data
		});
	}
}